import { ReactNode } from 'react';

import { Box } from '@mui/material';
import cx from 'classnames';

import styles from './SectionBox.module.scss';

interface SectionBoxProps {
  children: ReactNode;
  variant?: 'contained' | 'outlined';
}
export const SectionBox = ({
  children,
  variant = 'contained',
}: SectionBoxProps) => {
  return (
    <Box
      className={cx(styles.SectionBox, {
        [styles.Outlined]: variant === 'outlined',
        [styles.Contained]: variant === 'contained',
      })}
    >
      {children}
    </Box>
  );
};
